import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import MauvelousPrimaryButton from "../../common/button/mauvelousPrimaryButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import AddCapCourseDocument from "./AddCapCourseDocument";
import CapCourseDocumentTable from "./CapCourseDocumentTable";

export default function Index() {
  const naviagte = useNavigate();
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page");

 

  return (
    <Grid
      sx={{
        minHeight: "50vh",
        backgroundColor:
           "#fff",
        borderRadius: "8px",
      }}
    >
      {page === "document-list" && (
        <Grid container>
          <Grid
            item
            md={12}
            sx={{ display: "flex", justifyContent: "flex-end",py:1 }}
          >
            <MauvelousPrimaryButton
              title={"Add Cap Course Document"}
              handleClick={() =>
                naviagte(
                  `/${Cookies.get(
                    "mhet_mst_project"
                  )}/cap-course-document-master?page=addcapcoursedocument`
                )
              }
            />
          </Grid>
          <Grid item md={12}>
            <CapCourseDocumentTable />
          </Grid>
        </Grid>
      )}
      {page === "addcapcoursedocument" && <AddCapCourseDocument />}
      {page === "updatecapcoursedocument" && <AddCapCourseDocument />}
    </Grid>
  );
}
